import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=c160c74c&scoped=true"
import script from "./contractInfo.vue?vue&type=script&lang=js"
export * from "./contractInfo.vue?vue&type=script&lang=js"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=c160c74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c160c74c",
  null
  
)

export default component.exports